import axios from 'axios';
import axiosRetry from 'axios-retry';
import globalvariable from  '../api/global_variable';
import Message from 'iview/src/components/message';
import Modal from 'iview/src/components/modal';
import store from '../store';
// import { Message,Modal } from 'iview';
import tipsDialog from  '../include/tipsDialog';
import router from '../router';
import { localStorages } from '../api/storage/localStorage'
export function fetch(params){
  return new Promise((resolve,reject)=>{
    let headers = Object.assign({'Content-Type': 'text/plain;charset=UTF-8'},params.headers);
      const  instance = axios.create({
         baseURL:globalvariable.requestUrl,
         headers:headers,
         timeout: 30000 // 超时
       });
     axiosRetry(instance, { retries: 2, retryCondition: (error)=>{
        //true为打开自动发送请求，false为关闭自动发送请求
        //这里的意思是当请求方式为get时打开自动发送请求功能
        console.log(error);
        return (error.config.method === 'get' || error.config.method === 'post');
     }});
    instance(params.options).then(response=>{
         const  res = response;
         resolve(res);
       }).catch(err=>{
           //发生异常错误,请刷新页面重试,或联系程序员
         //提示
          reject(err);
        // errInfo(err);
       });

  })
}
export function fetchJson(params){
  return new Promise((resolve,reject)=>{
    //   console.log(store.state.user);
    let uid = store.state.user.uid ||  router.apps[0].$route.query.uid;
    let accessToken  = store.state.user.accesstoken || localStorages.get(`accesstoken_${uid}`);
    let headers = Object.assign({'accessToken':accessToken,'Content-Type': 'application/json'},params.headers);
    const  instance = axios.create({
      headers: headers,  //用来验证是否登录
      baseURL:globalvariable.requestUrl,
      timeout: 30000
    });
    axiosRetry(instance, { retries: 3, retryCondition: (error)=>{
        //true为打开自动发送请求，false为关闭自动发送请求
        //这里的意思是当请求方式为get时打开自动发送请求功能
        console.log(error);
        return (error.config.method === 'get' || error.config.method === 'post');
    }})
    instance(params.options).then(response=>{
      const  res = response;
      resolve(res);
    }).catch(err=>{
      reject(err);
     // errInfo(err);
    });

  })
}
export function fetchSessionJson(params){
    return new Promise((resolve,reject)=>{
         // let uid = store.state.user.uid ||  router.apps[0].$route.query.uid;
         let sessionToken  = store.state.user.sessionToken;
         let headers = Object.assign({'sessionToken':sessionToken,'Content-Type': 'application/json'},params.headers);
         const  instance = axios.create({
            headers: headers,  //用来验证是否登录
            baseURL:globalvariable.requestUrl,
            timeout: 30000
        });
       axiosRetry(instance,
        { retries: 3, retryCondition: (error)=>{
            //true为打开自动发送请求，false为关闭自动发送请求
            //这里的意思是当请求方式为get时打开自动发送请求功能
            console.log(error);
            return (error.config.method === 'get' || error.config.method === 'post');
          }})
        instance(params.options).then(response=>{
            const  res = response;
            resolve(res);
        }).catch(err=>{
          console.log(err);
          reject(err);
            // errInfo(err);
        });

    })
}
//sessionToken过期处理

//错误统一处理
function errInfo(err) {
  if(err.response != undefined){
    if(err && err.response.status && err.response.data.description){
      Modal.warning({
        width:'380',
        render:(h) => {
          return h(tipsDialog, {
            props:{
              title:'错误提示',
              content:`${err.response.data.description}`
            }
          })
        },
        onOk:()=>{
          // router.push({path:'/'});
        }
      });
      return
    }
  }else{
       /******接口访问失败******/
       Modal.warning({
         width:'380',
         render:(h) => {
           return h(tipsDialog, {
             props:{
               title:'错误提示',
               content:'请刷新浏览器或者联系管理员'
             }
           })
         },
         onOk:()=>{
           // router.push({path:'/'});
         }
       });
  }
}

